function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';

var PercentViewer = function PercentViewer(_ref) {
  var _ref$field = _ref.field,
      field = _ref$field === undefined ? {} : _ref$field,
      value = _ref.value,
      _ref$as = _ref.as,
      T = _ref$as === undefined ? 'span' : _ref$as,
      props = _objectWithoutProperties(_ref, ['field', 'value', 'as']);

  if (field.display) {
    var precision = parseInt(field.display, 10);
    return React.createElement(
      T,
      props,
      ' ',
      value.toFixed(precision),
      '\xA0% '
    );
  } else {
    return React.createElement(
      T,
      props,
      ' ',
      value,
      '\xA0% '
    );
  }
};
export { PercentViewer };